import { Stack } from "@mantine/core";
import { Questionnaire } from "src/graphql/generated/graphql";
import { CampaignQueryDataType } from "src/hooks/campaigns";

import { AssignmentDelivery } from "./delivery";
import { AssignmentGeneral } from "./general";
import { AssignmentImages } from "./images";
import { AssignmentOutcome } from "./outcome";
import { AssignmentProducts } from "./products";
import { AssignmentQuestionnaire } from "./questionnaire";

export interface AssignmentTabProps {
    campaign: CampaignQueryDataType;
    questionnaire: Questionnaire;
}

export const AssignmentTab = ({ campaign, questionnaire }: AssignmentTabProps) => {
    return (
        <Stack>
            <AssignmentGeneral campaign={campaign} />
            <AssignmentProducts campaign={campaign} />
            <AssignmentDelivery campaign={campaign} />
            <AssignmentOutcome campaign={campaign} />
            <AssignmentQuestionnaire questionnaire={questionnaire} />
            <AssignmentImages campaign={campaign} />
        </Stack>
    );
};
